import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Form, getIn } from 'formik';
import { withRouter } from 'react-router';
import lodashFindIndex from 'lodash/findIndex';

import getLastPageVisitedByScreenIdList from 'common/util/getLastPageVisitedByScreenIdList';

import {
  getListingApplicationFormUrl,
} from 'common/householdApplication/applicationHelpers';

import {
  isListingTenantScreening,
} from 'common/listingHelpers';

import getApplicationFormFields, {
  APPLICATION_FORM_TYPE_RENTER_PREQUAL,
} from 'common/householdApplication/applicationFormFields';

import {
  validateFormField,
  prepopulateFormFields,
} from 'client/helpers/formikHelpers';

import {
  SCREEN_ID_FEED,
  SCREEN_ID_FEED_CATEGORY,
} from 'client/constants/screenIds';

import HouseholdActions from 'client/actions/Household';

import Navbar from 'client/components/Navbar';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrLink from 'client/components/SrLink/SrLink';
import SrNavbarTitle from 'client/components/SrNavbarTitle';

import { FIELDS_GROUPS_STEPS } from 'common/householdApplication/rentalApplicationFormFields';

const {
  NODE_ENV,
} = process.env;

function makeApplicationFormFields({
  formikBag,
  roommates,
  formType,
  onFormFieldsReady,
  userId,
  listing,
}) {
  const applicationFormFields = getApplicationFormFields({
    formValues: formikBag.values,
    roommates: roommates,
    formType: formType,
    uploadAs: userId,
    listing: listing,
  });
  onFormFieldsReady(applicationFormFields);
}

@withRouter
class SrApplicationFormPage extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    fieldId: PropTypes.string.isRequired,
    formikBag: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    apiError: PropTypes.object,
    onFieldSubmit: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
    listingId: PropTypes.number,
    householdId: PropTypes.number,
    onFormFieldsReady: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
    dispatch: PropTypes.func.isRequired,
    backLink: PropTypes.string.isRequired,
    editMode: PropTypes.string,
    formType: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    buttonClassName: PropTypes.string,
    hasBuyersAgent: PropTypes.bool,
    application: PropTypes.object,
    screenIdHistory: PropTypes.array.isRequired,
    pathHistory: PropTypes.array.isRequired,
    saveExitRedirect: PropTypes.string,
    fieldGroup: PropTypes.string,
    listing: PropTypes.object,
  }

  componentDidMount() {
    makeApplicationFormFields(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.fieldId !== nextProps.fieldId) {
      makeApplicationFormFields(nextProps);
    }
  }

  render() {
    const {
      currentUser,
      roommates,
      formikBag,
      fieldId,
      isLoading,
      isSubmitting,
      apiError,
      onFieldSubmit,
      userId,
      listingId,
      householdId,
      history,
      dispatch,
      editMode,
      formType,
      buttonText,
      buttonClassName,
      backLink,
      hasBuyersAgent,
      prequalListingId,
      application,
      screenIdHistory,
      pathHistory,
      saveExitRedirect,
      fieldGroup,
      listing,
    } = this.props;

    const applicationFormFields = getApplicationFormFields({
      formValues: formikBag.values,
      roommates: roommates,
      formType: formType,
      uploadAs: userId,
      hasBuyersAgent,
      listing,
    });
    const formFieldIndex = lodashFindIndex(applicationFormFields, (formField) => {
      return formField.id.toLowerCase() === fieldId.toLowerCase();
    });
    const formField = applicationFormFields[formFieldIndex];

    if (!formField) {
      return (
        <Redirect to='/tour' />
      );
    }

    const nextFormField = applicationFormFields[formFieldIndex + 1];
    const progressPercentage = (formFieldIndex / applicationFormFields.length) * 100;

    const isValid = !validateFormField({
      validations: formField.validations,
      value: getIn(formikBag.values, formField.id),
      values: formikBag.values,
    });

    let rightButton = null;
    if (!(
      editMode === 'field'
      || (formType === APPLICATION_FORM_TYPE_RENTER_PREQUAL && !application.isPrequalCompleted)
    )) {
      let linkTo = '/profile';

      if (formType === APPLICATION_FORM_TYPE_RENTER_PREQUAL) {
        if (prequalListingId) {
          if (listing && isListingTenantScreening(listing)) {
            linkTo = `/apply/${prequalListingId}?showQualifications=true`;
          }
          else {
            linkTo = `/listing/${prequalListingId}?scrollTo=yourQualifications`;
          }
        }
        else {
          const lastPageVisited = getLastPageVisitedByScreenIdList({
            screenIdHistory,
            pathHistory,
            screenIdList: [
              SCREEN_ID_FEED,
              SCREEN_ID_FEED_CATEGORY,
            ],
          });
          linkTo = lastPageVisited ? lastPageVisited.path : '/feed';
        }
      }

      if (saveExitRedirect) {
        linkTo = saveExitRedirect;
      }

      rightButton = (
        <SrLink
          className='saveExit'
          to={linkTo}
          onClick={() => {
            if (isValid) {
              onFieldSubmit({
                formikBag: formikBag,
                nextFormField: nextFormField,
                formFieldId: formField.id,
                noRedirect: true,
              });
            }
          }}
        >
          Save & Exit
        </SrLink>
      );
    }

    let buttonLabel = isSubmitting ? 'loading...' : buttonText || (editMode === 'field' ? 'save' : 'next');

    if (fieldGroup && FIELDS_GROUPS_STEPS[fieldGroup]) {
      const haveMoreFields = FIELDS_GROUPS_STEPS[fieldGroup].includes(nextFormField.id);
      buttonLabel = haveMoreFields ? 'next' : 'save';
    }

    return (
      <div
        className={classnames(
          `applicationForm ${progressPercentage}%`,
          { fieldEditMode: editMode === 'field' }
        )}
      >
        <div className='progressBarContainer'>
          <div className='progressBar' style={{ width: `${progressPercentage}%` }} />
        </div>
        <Navbar
          leftButton={
            <SrLink to={backLink} />
          }
          rightButton={rightButton}
          customLogo={(
            <SrNavbarTitle title={currentUser.name.toLowerCase()} />
          )}
        />
        <div className='contentContainer'>
          {isLoading
            ? <div className='loading-gif clearfix' />
            : (apiError
              ? <div className='errorMessage'>{apiError}</div>
              : (
                <Form>
                  <SrFormikField
                    formikBag={formikBag}
                    formField={formField}
                  />
                  <ButtonDeprecated
                    type='button'
                    className={classnames('next', buttonClassName)}
                    disabled={isLoading || isSubmitting || !isValid}
                    onClick={() => {
                      onFieldSubmit({
                        formikBag: formikBag,
                        nextFormField: nextFormField,
                        formFieldId: formField.id,
                      });
                    }}
                  >
                    {buttonLabel}
                  </ButtonDeprecated>
                  {NODE_ENV === 'development' && (
                    <div>
                      <ButtonDeprecated
                        type='button'
                        onClick={() => history.push(getListingApplicationFormUrl({
                          userId: userId,
                          listingId: listingId,
                          householdId: householdId,
                          formFieldId: 'agreeTermsOfService',
                          formType: formType,
                        }))}
                      >
                        (dev) go to last step
                      </ButtonDeprecated>
                      <ButtonDeprecated
                        type='button'
                        onClick={() => {
                          prepopulateFormFields({
                            values: formikBag.values,
                            setFieldValue: formikBag.setFieldValue,
                            formFields: applicationFormFields,
                          });
                          dispatch(HouseholdActions.updateRenterProfile, {
                            userId: userId,
                            updates: formikBag.values,
                          }).then(() => {
                            history.push(getListingApplicationFormUrl({
                              userId: userId,
                              listingId: listingId,
                              householdId: householdId,
                              formFieldId: 'agreeTermsOfService',
                              formType: formType,
                            }));
                          });
                        }}
                      >
                        (dev) Prepopulate form
                      </ButtonDeprecated>
                    </div>
                  )}
                </Form>
              )
            )
          }
        </div>
      </div>
    );
  }
}

SrApplicationFormPage.displayName = 'SrApplicationFormPage';

export default SrApplicationFormPage;
